import * as APPOINTMENT from '@/store/constants/appointment';

export default {
  [APPOINTMENT.GET_APPOINTMENT_LIST]: (state) => {
    return state.list;
  }
}



// WEBPACK FOOTER //
// ./src/store/appointment/getters.js